import { render, staticRenderFns } from "./ChildObject.vue?vue&type=template&id=55b47920&scoped=true"
import script from "./ChildObject.vue?vue&type=script&lang=js"
export * from "./ChildObject.vue?vue&type=script&lang=js"
import style0 from "./ChildObject.vue?vue&type=style&index=0&id=55b47920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b47920",
  null
  
)

export default component.exports